import styled from 'styled-components';

const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  background-color: ${props => props.theme.color.backgroundRush};
  border-radius: 20px;
  margin-bottom: 40px;
`;

const ContainerTable = styled.div`
  margin: 0 -30px -10px;
`;
interface RowProps {
  planLength: number;
}
const Row = styled.div<RowProps>`
  display: grid;
  grid-template-columns: 275px 1fr 1fr 1fr ${props => props.planLength > 3 && '1fr'};
  grid-template-rows: auto;
`;

const FeatureHead = styled.div`
  display: flex;
  padding: 20px 20px 20px 30px;
  justify-content: space-between;
`;

const FeatureValue = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-left: 1px solid ${props => props.theme.color.background};
`;

const QuestionIcon = styled.div`
  svg {
    width: 20px;
    fill: ${p => p.theme.color.turquoise}
  }
  display: flex;
`;

export const Styled = {
  Container,
  ContainerTable,
  Row,
  FeatureHead,
  FeatureValue,
  QuestionIcon,
};
